var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Tooltip",
    {
      attrs: {
        title: "To add more managers you need to upgrade your subscription",
        tooltipClasses: "w-full",
        disabled: _vm.disabled,
        placement: "left",
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }